import { render, staticRenderFns } from "./MensagensVetoPorEnteFederativoPorTipoVeto.vue?vue&type=template&id=610b1fea&scoped=true"
import script from "./MensagensVetoPorEnteFederativoPorTipoVeto.vue?vue&type=script&lang=js"
export * from "./MensagensVetoPorEnteFederativoPorTipoVeto.vue?vue&type=script&lang=js"
import style0 from "./MensagensVetoPorEnteFederativoPorTipoVeto.vue?vue&type=style&index=0&id=610b1fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b1fea",
  null
  
)

export default component.exports